module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/art-desktop.f1f3c82c.png";